import { cn } from "@/lib/utils";

/**
 * Crimson waveform lines radiating out of the D.A.R. mic button while Hey MR is
 * listening or speaking. Purely decorative: it never intercepts taps, so the
 * mic underneath still starts a D.A.R. voice memo.
 */
const BARS = [0.4, 0.68, 0.92, 1, 0.78, 0.55, 0.36];

export function MrVoiceWaves({
  speaking,
  compact = false,
  standby = false,
}: {
  speaking?: boolean;
  compact?: boolean;
  standby?: boolean;
}) {
  const bars = compact ? BARS.slice(0, 4) : BARS;
  // Standby (waiting for "Hey MR") is a calm, shorter, slower breath so it never
  // reads as active recording.
  const peak = standby ? (compact ? 12 : 15) : speaking ? (compact ? 26 : 32) : compact ? 20 : 24;

  return (
    <span aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
      {(["left", "right"] as const).map((side) => (
        <span
          key={side}
          className={cn(
            "absolute flex h-10 items-center",
            compact ? "gap-0.5" : "gap-1",
            side === "left"
              ? cn("right-full flex-row-reverse", compact ? "mr-0.5" : "mr-2")
              : cn("left-full", compact ? "ml-0.5" : "ml-2"),
          )}
        >
          {bars.map((h, i) => (
            <span
              key={i}
              className={cn(
                "mr-wave-bar rounded-full bg-[#cc0000] shadow-[0_0_9px_rgba(204,0,0,0.75)]",
                compact ? "w-0.5" : "w-[3px]",
              )}
              style={{
                height: `${Math.round(h * peak)}px`,
                animationDelay: `${i * 90}ms`,
                animationDuration: standby ? "1800ms" : speaking ? "700ms" : "900ms",
                opacity: standby ? 0.55 : 1,
              }}
            />
          ))}
        </span>
      ))}
    </span>
  );
}
